import { NgModule, inject } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';

import { loggedInAccessGuard } from '@core/guards';
import { environment } from 'environments/environment';

import { integrationGuard } from './core/guards/integration.guard';
import { jwtLoginGuard } from './core/guards/jwt-login.guard';
import { integrationsPagesRoutes } from './integrations/integrations.routes';
import { AppPageComponent } from './pages';
import { commonPagesRoutes } from './pages/routes';

const routes: Routes = [
    {
        path: '',
        canActivate: [integrationGuard, jwtLoginGuard],
        children: [
            {
                path: '',
                component: AppPageComponent,
                canActivateChild: [loggedInAccessGuard],
                children: [
                    {
                        path: '',
                        loadChildren: () => import('./app-main/app-main.module').then((m) => m.AppMainModule),
                    },
                    {
                        path: 'playground', // development purposes only
                        loadChildren: () => import('./playground/playground.routes').then((m) => m.routes),
                        canActivate: [() => !environment.production || inject(Router).createUrlTree(['login'])],
                    },
                ],
            },
            {
                path: 'unsubscribe',
                loadChildren: () => import('./unsubscribe/unsubscribe.routes').then((m) => m.routes),
            },
            ...integrationsPagesRoutes,
        ],
    },
    ...commonPagesRoutes,
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
